import Vue from 'vue';
import Router from 'vue-router';
import CommunitySpace from '@/views/CommunitySpace.vue';
import CommunityCommon from '@/views/community/CommunityCommon.vue';
import CommunityHome from '@/views/community/home/CommunityHome.vue';
import HomeSpace from '@/views/community/home/HomeSpace.vue';
import CategorySpace from '@/views/community/home/CategorySpace.vue';
import TopicSpace from '@/views/community/home/TopicSpace.vue';
import ChatSpace from '@/views/community/chat/ChatSpace.vue';
import ChatScreen from '@/views/community/chat/ChatScreen.vue';
import CalendarSpace from '@/views/community/CalendarSpace.vue';
import UsersSpace from '@/views/community/UsersSpace.vue';
import AboutSpace from '@/views/community/AboutSpace.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: CommunitySpace,
    },
    {
      path: '/c/:communityId',
      component: CommunityCommon,
      children: [
        {
          path: '/',
          component: CommunityHome,
          children: [
            {
              path: '/',
              component: HomeSpace,
            },
            {
              path: 'category/:categoryId',
              component: CategorySpace,
            },
            {
              path: 'topic/:topicId',
              component: TopicSpace,
            },
          ],
        },
        {
          path: 'chat',
          component: ChatSpace,
        },
        {
          path: 'chat/:chatId',
          component: ChatScreen,
        },
        {
          path: 'calendar',
          component: CalendarSpace,
        },
        {
          path: 'users',
          component: UsersSpace,
        },
        {
          path: 'setting',
          component: AboutSpace,
        },
      ],
    },
  ],
  scrollBehavior() {
    // page scroll to top for all route navigations
    return { x: 0, y: 0 };
  },
});
